import { createFileRoute } from "@tanstack/react-router";
import PLDashboard from "../../../../../views/pl/Dashboard";

export const Route = createFileRoute("/_authenticated/user/pl/report/")({
  component: PLDashboard,
});
